import { render, staticRenderFns } from "./CertificationList.vue?vue&type=template&id=196fa03c&scoped=true&"
import script from "./CertificationList.vue?vue&type=script&lang=js&"
export * from "./CertificationList.vue?vue&type=script&lang=js&"
import style0 from "./CertificationList.vue?vue&type=style&index=0&id=196fa03c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196fa03c",
  null
  
)

export default component.exports